import React, { useEffect, useState } from 'react'
import AdminSidebar from '@components/admin/AdminSidebar'
import BaseTable from '@components/shared/BaseTable'
import { QueryFunctionContext, useQuery, useQueryClient } from 'react-query'
import { api } from '@api/index'
import usePagenation from '@hooks/usePagenation'
import { Link, useNavigate } from 'react-router-dom'
import { FieldValues, useForm } from 'react-hook-form'
import StBaseSelect from '@components/shared/StBaseSelect'
import 'twin.macro'

const rowSize = 8

const fetchPostList = ({ queryKey }: QueryFunctionContext) => {
  const [_, page, searchKeyword] = queryKey
  return api.adminService.getPostList({
    size: rowSize,
    page: (page as number) - 1, //서버측 pageIndex는 0부터 시작
    sort: 'id,desc',
    search: searchKeyword as PagenationSearchOption<PostSearchBase>,
  })
}

interface FromValues {
  searchOption: string
  searchKeyword: string
}

const AdminPostManagement = () => {
  const [checkedPosts, setCheckedPosts] = useState<Set<number>>(new Set())
  const [searchKeyword, setSearchKeyword] =
    useState<PagenationSearchOption<PostInfo>>('title,')
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm<FromValues>({
    mode: 'onChange',
  })

  const {
    pagelist,
    currentPage,
    goBeforeSection,
    goNextSection,
    goNext,
    goBefore,
    setListRefIndex,
    setTotalPage,
  } = usePagenation(5)

  const {
    isLoading,
    error,
    data: { totalPages, content } = {} as PostPagenationInfo,
  } = useQuery(['PostList', currentPage, searchKeyword], fetchPostList, {
    refetchOnWindowFocus: false,
    onSuccess: (data) => {
      setTotalPage(data.totalPages)
    },
  })

  useEffect(() => {
    const nextPage = currentPage + 1
    if (nextPage > totalPages) return
    queryClient.prefetchQuery(
      ['PostList', nextPage, searchKeyword],
      fetchPostList
    )
  }, [currentPage, queryClient, totalPages, searchKeyword])

  const handleUserListRowClick = (uuid: number) => {
    navigate(`/admin/post-management/${uuid}`)
  }

  const handleSearchClick = (form: FromValues) => {
    const { searchOption, searchKeyword } = form
    const searchParams =
      `${searchOption},${searchKeyword}` as PagenationSearchOption<PostInfo>
    setSearchKeyword(searchParams)
  }

  const handleChangeCheckBox = (postId: number) => {
    if (!checkedPosts.has(postId)) {
      setCheckedPosts(new Set([...checkedPosts, postId]))
    } else {
      const copyed = new Set([...checkedPosts])
      copyed.delete(postId)
      setCheckedPosts(copyed)
    }
  }

  const handleDeletePost = () => {
    console.log(checkedPosts)
  }

  return (
    <>
      <form onSubmit={handleSubmit(handleSearchClick)}>
        <section tw="w-1200 flex gap-32">
          <AdminSidebar />
          <main tw="w-full ">
            <h1 tw="text-2xl border-b-2 font-bold pb-10 border-neutral-400">
              게시판 관리
            </h1>
            <div tw="flex  items-center gap-3 mt-20">
              <Link to={'/admin/post-management/add'}>
                <button type="button" className="button base">
                  공지등록
                </button>
              </Link>
              <button
                onClick={handleDeletePost}
                type="button"
                tw="ml-3"
                className="button base"
              >
                삭제
              </button>
              <StBaseSelect
                {...register('searchOption')}
                tw="ml-auto py-0 px-10 w-100"
                className="input"
              >
                <option value="all">전체</option>
                <option value="title">제목</option>
                <option value="content">내용</option>
                <option value="nickname">닉네임</option>
                <option value="mine">내글</option>
              </StBaseSelect>
              <input
                {...register('searchKeyword')}
                tw="w-200"
                className="input"
                placeholder="검색어 입력"
              />
              <button className="button base">검색</button>
            </div>
            <div tw="py-20">
              <BaseTable
                column={[
                  ['', 2],
                  ['글번호', 4],
                  ['제목', 4],
                  ['등록일', 5],
                  ['등록자', 5],
                  ['조회수', 3],
                ]}
              >
                {content?.map(({ id, title, createdAt, author, views }) => (
                  <tr
                    onClick={() => handleUserListRowClick(id)}
                    key={id}
                    tw="cursor-pointer hover:bg-neutral-200"
                  >
                    <td onClick={(e) => e.stopPropagation()}>
                      <input
                        type="checkbox"
                        onChange={() => handleChangeCheckBox(id)}
                      ></input>
                    </td>
                    <td>{id}</td>
                    <td>{title}</td>
                    <td>{createdAt}</td>
                    <td>{author.nickname}</td>
                    <td>{views}</td>
                  </tr>
                ))}
              </BaseTable>
            </div>
            <div tw="w-full flex justify-center gap-8 mt-10">
              {' '}
              <button
                type="button"
                className="button base"
                onClick={goBeforeSection}
              >
                {'<<'}
              </button>
              <button type="button" className="button base" onClick={goBefore}>
                {'<'}
              </button>
              {pagelist.map((num, idx) => (
                <button
                  type="button"
                  className="button base"
                  onClick={() => setListRefIndex(idx)}
                  key={num}
                >
                  {num}
                </button>
              ))}
              <button type="button" className="button base" onClick={goNext}>
                {'>'}
              </button>
              <button
                type="button"
                className="button base"
                onClick={goNextSection}
              >
                {'>>'}
              </button>
            </div>
          </main>
        </section>
      </form>
    </>
  )
}

export default AdminPostManagement
